import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainUnBindDevice(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/unBindDevice`,
    method: "post",
    params,
  });
}
